import React from "react";
import { Box, CircularProgress, Typography, Chip } from "@mui/material";
import { ToolExecutingProps } from "./toolLoadingRegistry";

export const DefaultToolExecuting: React.FC<ToolExecutingProps> = ({
  toolName,
  args,
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
      <Box
        sx={{
          p: 2,
          bgcolor: "primary.50",
          borderRadius: 1,
          border: "1px solid",
          borderColor: "primary.200",
          maxWidth: "70%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
          <CircularProgress size={16} />
          <Chip
            label={toolName}
            size="small"
            variant="outlined"
            color="primary"
          />
        </Box>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Executing tool...
        </Typography>
        
        {args && Object.keys(args).length > 0 && (
          <Typography
            variant="body2"
            sx={{
              fontFamily: "monospace",
              whiteSpace: "pre-wrap",
              bgcolor: "grey.100",
              p: 1,
              borderRadius: 0.5,
              fontSize: "0.75rem",
            }}
          >
            {JSON.stringify(args, null, 2)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};